/* eslint-disable jira/filename-case */
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { RESULTS } from './results.constants.tsx';

export const Field = {
	createdSuccess: (event: UIAnalyticsEvent, attributes: object): void => {
		// https://data-portal.internal.atlassian.com/analytics/registry/51308
		fireTrackAnalytics(event, 'issueField created', attributes);
	},
	createdFailure: (event: UIAnalyticsEvent, fieldType: string): void => {
		// https://data-portal.internal.atlassian.com/analytics/registry/47737
		fireTrackAnalytics(event, 'ideaField created', {
			result: RESULTS.FAILURE,
			fieldType,
		});
	},
};
